/**
 * @generated SignedSource<<1c0813e61f4769dd34dea8db684b252f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type newsletterColumnistSlideshowAppConfigQuery$data = {
  readonly newslettersColumnist: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "newsletterColumnistSlideshowAppConfigQuery";
};
export type newsletterColumnistSlideshowAppConfigQuery$key = {
  readonly " $data"?: newsletterColumnistSlideshowAppConfigQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"newsletterColumnistSlideshowAppConfigQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "newsletterColumnistSlideshowAppConfigQuery",
  "selections": [
    {
      "alias": "newslettersColumnist",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "scmp_pwa_newsletter_columnist"
          }
        }
      ],
      "concreteType": "AppConfig",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "json",
          "storageKey": null
        }
      ],
      "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_newsletter_columnist\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "4f930fe92e668b32944b6cf51718950d";

export default node;
